export class QueryFrom {
  entity: string
}
